export default "__VITE_ASSET__2fa48241__"